/** biome-ignore-all lint/suspicious/noExplicitAny: its a generic utility ignroing any actual types */
import { DatabaseEngine, type DatabaseEngineType } from '@pkg/db/query'
import { environmentManager } from '@tanstack/react-query'
import type { Kysely, QueryExecutor, SelectQueryBuilder } from 'kysely'

export const isSqliteDatabase = (db: QueryExecutor) => {
  return db.adapter.constructor.name === 'SqliteAdapter'
}

export const isPostgresDatabase = (db: QueryExecutor) => {
  return db.adapter.constructor.name === 'PostgresAdapter'
}

export type InferrableDatabaseEngineType =
  | Kysely<any>
  | DatabaseEngineType
  | SelectQueryBuilder<any, any, any>
  | QueryExecutor

export const inferDatabaseEngine = (db: InferrableDatabaseEngineType): DatabaseEngineType => {
  if (typeof db === 'string') {
    return db
  }
  if ((db as SelectQueryBuilder<any, any, any>).isSelectQueryBuilder && (db as any)['#props']) {
    return inferDatabaseEngine((db as any)['#props'].executor as QueryExecutor)
  }
  if ('getExecutor' in db) {
    return inferDatabaseEngine(db.getExecutor())
  }
  if ('adapter' in db) {
    if (isPostgresDatabase(db)) {
      return DatabaseEngine.postgres
    }
    if (isSqliteDatabase(db)) {
      return DatabaseEngine.sqlite
    }
  }
  if (!environmentManager.isServer()) {
    return DatabaseEngine.sqlite
  }
  return DatabaseEngine.postgres
}
